module.exports = __webpack_public_path__ + "img/main_title.e33faad4.png";